module.exports = __webpack_public_path__ + "images/canonical-card/bouncer-taco.5ee77a1458fc988cc9bc.svg";